import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import { TABS, TABS_BUTTONS } from "./constants";
import Edit from "pages/meter-management/meter-spare-parts/editSparePart/Tabs/Edit";
import View from "pages/meter-management/meter-spare-parts/editSparePart/Tabs/View";
import { useSelector } from "react-redux";
import { MeterCommandsSelector } from "store/meter-management/meters/selectors";
import Receive from "pages/meter-management/meter-spare-parts/editSparePart/Tabs/Receive";
import { userHasAdminRole, userHasOneOfRoles } from "utils/helpers/functions";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 30,
    display: "flex",
  },
  container: {
    borderRadius: 30,
    width: "100%",
    padding: 30,
  },
  tabs: {
    display: "flex",
    padding: "30px 0",
    fontSize: 13,
    fontWeight: 600,
    flexDirection: "column",
    marginRight: -4,
  },
  tab: {
    backgroundColor: "#E1E1E1",
    padding: 15,
    borderRadius: "10px 0 0 10px",
    marginBottom: 10,
    whiteSpace: "nowrap",

    "&:hover": {
      cursor: "pointer",
    },
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  cardBody: {
    padding: 0,
  },
});

const DataTabs = ({ id }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(TABS.DETAILS);
  const { activeSparePart } = useSelector(MeterCommandsSelector);

  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {TABS_BUTTONS.map(item => {
          if (item?.hideRoles && !userHasAdminRole() && userHasOneOfRoles(item?.hideRoles)) return null;
          return (
            <div
              key={item.key}
              className={classnames(classes.tab, activeTab === item.key && classes.active)}
              data-tab={item.key}
              onClick={onTabClick}
            >
              {item.title}
            </div>
          );
        })}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          {activeTab === TABS.EDIT && <Edit data={activeSparePart} id={id} />}
          {activeTab === TABS.DETAILS && <View data={activeSparePart} id={id} />}
          {activeTab === TABS.RECEIVE && <Receive id={id} />}
        </CardBody>
      </Card>
    </div>
  );
};

export default DataTabs;
